// Types
import Immutable from 'immutable';
import { MNElementSummary } from '../../../common/elements/elementModelTypes';

export const getElementSummariesSelector = (state: Immutable.Map<string, unknown>): Map<string, MNElementSummary> =>
    state.getIn(['cache', 'elementSummaries']) as Map<string, MNElementSummary>;
